<template>
<div class="chapter">
<div class="inner_page">
<div class="cover">
<img alt="An Occupation of Angels by Lavie Tidhar" src="images/cover.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Cover.vue?5c18004e